import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { FDStack, tokens } from '@facet-wealth/design';

const useStyles = buildUseStyles('FeaturedActionItem', (theme) => ({
  dot: {
    width: theme.spacing(1),
    height: theme.spacing(1),
    borderRadius: '50%',
    backgroundColor: tokens.color_grey_30,
  },
  dotFilled: {
    backgroundColor: tokens.color_oceana_800,
  },
}));

export const PillarStepper = ({ dashboardResource }) => {
  const classes = useStyles();

  const selectedPillar = dashboardResource.attr('selectedPillar');
  const pillarResources = React.useMemo(() => dashboardResource.attr('progress')?.resources().head().attr('items')
    ?.resources()
    .list() || [], [dashboardResource]);

  if (!(selectedPillar && pillarResources.length > 0)) {
    return null;
  }

  return (
    <FDStack width={'100%'} justifyContent={'center'} alignItems={'center'} spacing={1}>
      {pillarResources.map((v) => {
        return (
          <div
            key={v.id()} // eslint-disable-line react/no-array-index-key
            className={classNames(classes.dot, {
              [classes.dotFilled]: v.id() === selectedPillar,
            })}
          />
        );
      })}
    </FDStack>
  );
};

PillarStepper.defaultProps = {
};

PillarStepper.propTypes = {
  dashboardResource: PropTypes.object.isRequired,
};
